export default __webpack_public_path__ + "static/media/welcome-header.589414bc.png";